import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-namecard 127",
  "use": "icon-namecard 127-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-namecard 127\"><path d=\"M810.666667 234.666667a64 64 0 0 1 64 64v426.666666a64 64 0 0 1-64 64H213.333333a64 64 0 0 1-64-64V298.666667a64 64 0 0 1 64-64h597.333334z m0 64H213.333333v426.666666h597.333334V298.666667z m-42.666667 298.666666v64H256v-64h512zM469.333333 341.333333v192H256v-192h213.333333z m298.666667 128v64H512v-64h256z m-362.666667-64h-85.333333v64h85.333333v-64z\" p-id=\"12719\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol